import { requests } from 'api';
import { Occupation } from './types';

const apiBaseUrl = '/api/occupations';

export const OccupationsApi = {
  getAll: (): Promise<Occupation[]> => requests.get(apiBaseUrl),
};
